import React, {useRef, useEffect} from "react";
import "../Styles/Rooms.scss";
import doubleRoom from "../Image/img40.JPG";
import tripleRoom from "../Image/img39.JPG";
import quadRoom from "../Image/quadroom.webp";
import { Link } from "react-router-dom";

const roomsData = [
  {
    type: "Double Room",
    description:
      "Indulge in the refined elegance of our Double Room, featuring plush king-size bedding, bespoke furniture, and a private balcony overlooking serene vistas. Perfect for couples seeking intimate luxury.",
    image: doubleRoom,
    features: ["King Bed", "Private Balcony", "Luxury Bath Amenities", "City View"],
  },
  {
    type: "Triple Room",
    description:
      "Our Triple Room blends spacious comfort with exquisite design. Ideal for families or friends, offering three premium beds, ambient lighting, and a sophisticated lounge area.",
    image: tripleRoom,
    features: ["Three Beds", "Lounge Area", "Luxury Bath Amenities", "City View"],
  },
  {
    type: "Quadruple Room",
    description:
      "Experience unparalleled space in our Quadruple Room, designed for groups or families. Elegant décor, high-end furnishings, and advanced climate control ensure a lavish stay.",
    image: quadRoom,
    features: ["Four Beds", "Spacious Living Area", "Premium Bathroom", "City View"],
  },
];

const Rooms = () => {
  const sectionRefs = useRef([]);
  const imageRefs = useRef([]);

  // Scroll animations + parallax
  useEffect(() => {
    const handleScroll = () => {
      sectionRefs.current.forEach((section, i) => {
        if (!section) return;
        const rect = section.getBoundingClientRect();
        // Fade-in
        if (rect.top < window.innerHeight * 0.85) {
          section.classList.add("visible");
        }

        // Parallax effect
        const image = imageRefs.current[i];
        if (image) {
          const speed = 0.3; // smaller number = slower, subtle parallax
          const offset = window.scrollY - section.offsetTop;
          image.style.transform = `translateY(${offset * speed}px)`;
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initial check
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

  return (
    <div className="rooms-page">
      <h1 className="page-title">OUR ROOMS</h1>

      {roomsData.map((room, index) => (
        <section
          key={index}
          className={`room-section ${index % 2 === 0 ? "even" : "odd"}`}
          ref={(el) => (sectionRefs.current[index] = el)}
        >
          <div className="room-content">
            <div
              className="room-image"
              ref={(el) => (imageRefs.current[index] = el)}
            >
              <img src={room.image} alt={room.type} loading="lazy" />
            </div>
            <div className="room-details">
              <h2>{room.type}</h2>
              <p>{room.description}</p>
              <ul>
                {room.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
             <Link to="/contact" ><button onClick={scrollToTop}>Book Now</button></Link>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Rooms;

// const roomsData = [
//   {
//     type: "Double Room",
//     description:
//       "Indulge in the refined elegance of our Double Room, featuring plush king-size bedding, bespoke furniture, and a private balcony overlooking serene vistas. Perfect for couples seeking intimate luxury.",
//     image: doubleRoom,
//     features: ["King Bed", "Private Balcony", "Luxury Bath Amenities", "Sea View"],
//   },
//   {
//     type: "Triple Room",
//     description:
//       "Our Triple Room blends spacious comfort with exquisite design. Ideal for families or friends, offering three premium beds, ambient lighting, and a sophisticated lounge area.",
//     image: tripleRoom,
//     features: ["Three Beds", "Lounge Area", "Luxury Bath Amenities", "City View"],
//   },
//   {
//     type: "Quadruple Room",
//     description:
//       "Experience unparalleled space in our Quadruple Room, designed for groups or families. Elegant décor, high-end furnishings, and advanced climate control ensure a lavish stay.",
//     image: quadRoom,
//     features: ["Four Beds", "Spacious Living Area", "Premium Bathroom", "Panoramic View"],
//   },
// ];

// const Rooms = () => {
//   const sectionRefs = useRef([]);

//   // Scroll-triggered animations
//   useEffect(() => {
//     const handleScroll = () => {
//       sectionRefs.current.forEach((ref) => {
//         if (!ref) return;
//         const rect = ref.getBoundingClientRect();
//         if (rect.top < window.innerHeight * 0.85) {
//           ref.classList.add("visible");
//         }
//       });
//     };

//     window.addEventListener("scroll", handleScroll);
//     handleScroll(); // initial check
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div className="rooms-page">
//       <h1 className="page-title">OUR ROOMS</h1>

//       {roomsData.map((room, index) => (
//         <section
//           key={index}
//           className={`room-section ${index % 2 === 0 ? "even" : "odd"}`}
//           ref={(el) => (sectionRefs.current[index] = el)}
//         >
//           <div className="room-content">
//             <div className="room-image">
//               <img src={room.image} alt={room.type} loading="lazy" />
//             </div>
//             <div className="room-details">
//               <h2>{room.type}</h2>
//               <p>{room.description}</p>
//               <ul>
//                 {room.features.map((feature, idx) => (
//                   <li key={idx}>{feature}</li>
//                 ))}
//               </ul>
//               <button>Book Now</button>
//             </div>
//           </div>
//         </section>
//       ))}
//     </div>
//   );
// };

// export default Rooms;